import { getConfig } from "../../config";
import apiFetcher from "../apiFetcher";
import { CoreContext } from "./coreContext";
import { Error as CoreError } from "./coreSchemas";

const getBaseUrl = () =>
  getConfig().api.core?.baseUrl || "http://localhost:5000";

export type ErrorWrapper<TError> =
  | TError
  | (CoreError & {
      status: number;
    });

export type CoreFetcherOptions<TBody, THeaders, TQueryParams, TPathParams> = {
  url: string;
  method: string;
  body?: TBody;
  headers?: THeaders;
  queryParams?: TQueryParams;
  pathParams?: TPathParams;
  signal?: AbortSignal;
} & CoreContext["fetcherOptions"];

export async function coreFetch<
  TData,
  TError,
  TBody extends {} | FormData | undefined | null,
  THeaders extends {},
  TQueryParams extends {},
  TPathParams extends {},
>(
  options: CoreFetcherOptions<TBody, THeaders, TQueryParams, TPathParams>,
): Promise<TData> {
  // generated code replaced
  return apiFetcher({
    ...options,
    name: "core",
    baseUrl: getBaseUrl(),
  });
}
